import React, {useEffect} from "react";
import {connect, useDispatch} from "react-redux";
import {t} from "../i18n";
import {AppState} from "../RootReducer";
import {fetchBonusInfo, setDisplayTermsForBonusConfigId} from "./BonusActions";
import {CurrencyDefinition, UserBonusView} from "../http/protocol";
import Translator from "../Translator";
import {Big} from "big.js";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import {getContainer} from "../ioc/IOCSetup";
import {formatDate} from "../utils/date";
import "./BonusPage.scss";
import {ProgressBar} from "react-bootstrap";
import {ConfirmButton} from "../ui/ConfirmButton";
import UFO from "../assets/cow_ufo.png";
import { fetchBalance, setActiveCurrency } from "../user/UserActions";
import {AccountCard} from "../ui/AccountUI";
import {getIconFromProduct} from "./NextBonuses";


export const ActiveBonuses = (props : { bonuses : UserBonusView[], activeCurrency:string, setActiveCurrency(cc:string): typeof setActiveCurrency, firstActiveCurrency:string}) => {

    const active:boolean = !!props.bonuses.find(bonus => bonus.currency === props.activeCurrency);
    let bonuses:any[] = [];

    bonuses = props.bonuses.filter(b => b.currency === props.activeCurrency).map(b => (
        <ActiveBonus key={b.id} userBonus={b}/>
    ));
    return (
        <>
            {active && (
                <>
                    <h4 className={"section"}>
                       {t("bonus.active")}
                    </h4>
                    {bonuses}
                </>
            )}
            <div className={"row notFound-content"}>
                {bonuses.length === 0 && (
                    <div className="notFound-wrapper">
                        <img className={"notFound"} src={UFO} alt={"Not found"}
                             style={{background: `url(${UFO}) no-repeat`, backgroundSize: 'cover'}}/>
                        {props.firstActiveCurrency.length > 0 && (
                            <>
                                <br/>
                                <p>{t("bonus.bonusOfferOther", {currencyCode:props.firstActiveCurrency})}</p>
                                <button onClick={(e) => {
                                    if(typeof props.setActiveCurrency === "function") {
                                        props.setActiveCurrency(props.firstActiveCurrency)
                                    }
                                }} className="btn btn-primary">{t("bonus.switch-button", {currencyCode:props.firstActiveCurrency})}</button>
                            </>
                        )}
                        {
                            props.firstActiveCurrency.length === 0 &&(<p className={"notFound-text"}>{t("bonus.bonusOffersEmpty")}</p>)
                        }
                    </div>
                )}
            </div>
        </>
    )
}
interface ActiveBonusProps {
    userBonus : UserBonusView;
    currency? : CurrencyDefinition;
    fetchBonusInfo? : () => void;
}
const ActiveBonusImpl = (props : ActiveBonusProps) => {
    let b : UserBonusView = props.userBonus;
    let progress = "0";
    let currentTurnover = 0;
    let turnoverRequirement = 0;

    const dispatch = useDispatch();
    const openTerms = () => dispatch(setDisplayTermsForBonusConfigId(props.userBonus.bonusConfig?.id));

    useEffect(() => {
        return function cleanup() {
            _isMounted = false;
        }
    })

    if(b.currentTurnover) {
        currentTurnover = b.currentTurnover;
    }
    if(b.turnoverRequirement) {
        turnoverRequirement = b.turnoverRequirement;
    }
    if(!b.bonusConfig) {
        return <div/>
    }
    let bc = b.bonusConfig;
    if(turnoverRequirement !== 0) {
        progress =  new Big(currentTurnover).div(new Big(turnoverRequirement)).times(100).toFixed(0) ;
    }
    const amount = CurrencyFormatter.formatWithSymbol(props.currency,b.totalBonusAmount);

    let  _isMounted:boolean = true;

    return (
        <AccountCard>
            <div className={"row"}>
                {bc.imageUrl && bc.imageUrl.trim().length > 0 && (
                    <div className={"col-md-2 image"}>
                        <div className={"bonus-image"} style={{ backgroundImage : `url('${bc.imageUrl}')`}}></div>
                    </div>
                )}
                <div className={"col-md-6 content"}>
                    <h4>
                        {bc.translations && <Translator defaultTranslation={bc.name} translations={bc.translations.map(t=>({lng : t.language, value : t.name})) as any} />} {amount}
                    </h4>
                    <div className={"receive-amount"}>
                        {bc.type == "BOUNTY"  &&
                            t("bonus.receive-active", { bonusAmount :CurrencyFormatter.formatWithSymbol(props.currency,b.totalBonusAmount) })
                        }

                        {bc.type == "PARACHUTE"  &&
                            t("bonus.receive-active-parachute")
                        }

                    </div>

                    { (bc.type == "PARACHUTE"  &&  !b.parachuteBonusPhase)  &&
                        <div>
                            {t("bonus.turnover-not-started-parachute")}
                        </div>
                    }

                    { (bc.type == "BOUNTY" ||  bc.type == "PARACHUTE")  &&
                        <div className={"bonus-progress"}>
                            <ProgressBar label={
                                <span>{parseInt(progress) >= 100 ? 100 : `${progress}%`}</span>
                            } now={parseInt(progress)} max={100} min={0} />
                            {CurrencyFormatter.formatWithSymbol(props.currency, currentTurnover)}  / {CurrencyFormatter.formatWithSymbol(props.currency, turnoverRequirement)}
                        </div>
                    }

                    <div className={"expires"}>
                        <i className={"material-icons"}>schedule</i> {t("bonus.expires")} <span>{formatDate(b.expires)}</span>
                    </div>
                    <div className={"bonus-details"}>
                        <a href="#" onClick={openTerms} className={"popup-link"}>
                            <i className="material-icons">info</i>{t("bonus.terms.terms-link")}
                        </a>
                        { bc.turnoverContributions?.contributions?.map(c => {
                                const ic = getIconFromProduct(c.product)
                                return <i key={c.id} className={ic.className}>{ic.text}</i>
                            })
                        }
                    </div>
                </div>
                <div className={"col-md-4 actions"}>
                    <ConfirmButton className={"btn btn-cta small"}
                                   onConfirm={async ()=>{
                                        await getContainer().getUserBonusService().cancelBonus(b.id)
                                        dispatch(fetchBalance() as any);
                                        props.fetchBonusInfo && props.fetchBonusInfo();
                                   }
                                   }
                                   label={t("bonus.cancel-bonus.button-label")}
                                   errorText={t("bonus.cancel-bonus.error-text")}
                                   confirmText={t("bonus.cancel-bonus.confirm-text")}
                                   confirmTitle={t("bonus.cancel-bonus.confirm-header")}
                                   customCancelText={t("bonus.cancel-bonus.custom-cancel-label")}
                    />

                </div>
            </div>

        </AccountCard>
    )
}
export const ActiveBonus = connect((app : AppState, props : ActiveBonusProps)=>{
    if(!app.settings.settings || !app.settings.settings.currencies) {
        return {};
    }
    if(!props.userBonus || !props.userBonus.bonusConfig || !props.userBonus.bonusConfig.monetaryConfig) {
        return {};
    }
    let currency = props.userBonus.bonusConfig.monetaryConfig.currencyCode;
    return {
        currency : app.settings.settings.currencies.find( (c) => c.code == currency)
    }

}, (dispatch => {
    return {
        fetchBonusInfo : () => dispatch(fetchBonusInfo() as any)
    }
}))(ActiveBonusImpl);
